

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"height":"80","viewBox":"0 0 81 80","width":"81","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"fill":"none"}, [h('circle', {"cx":"40.322","cy":"39.822","r":"39.822"}, []), h('path', {"d":"m59.409 28.948h-32.833l1.933-10.148h32.833zm-17.474 16.197h-18.438l1.93-10.151h18.438zm4.373 16.197h-25.897l1.933-10.148h25.894z","fill":"#fff"}, [])])]);
};

        